module.exports = __webpack_public_path__ + "static/media/category1.3d089bc2.jpg";